export default [
  { label: '🇦🇫 +93', code: '93', id: 'af' },
  { label: '🇦🇱 +355', code: '355', id: 'al' },
  { label: '🇩🇿 +213', code: '213', id: 'dz' },
  { label: '🇦🇩 +376', code: '376', id: 'ad' },
  { label: '🇦🇴 +244', code: '244', id: 'ao' },
  { label: '🇦🇬 +1', code: '1', id: 'ag' },
  { label: '🇦🇷 +54', code: '54', id: 'ar' },
  { label: '🇦🇲 +374', code: '374', id: 'am' },
  { label: '🇦🇺 +61', code: '61', id: 'au' },
  { label: '🇦🇹 +43', code: '43', id: 'at' },
  { label: '🇦🇿 +994', code: '994', id: 'az' },
  { label: '🇧🇸 +1', code: '1', id: 'bs' },
  { label: '🇧🇭 +973', code: '973', id: 'bh' },
  { label: '🇧🇩 +880', code: '880', id: 'bd' },
  { label: '🇧🇧 +1', code: '1', id: 'bb' },
  { label: '🇧🇾 +375', code: '375', id: 'by' },
  { label: '🇧🇪 +32', code: '32', id: 'be' },
  { label: '🇧🇿 +501', code: '501', id: 'bz' },
  { label: '🇧🇯 +229', code: '229', id: 'bj' },
  { label: '🇧🇹 +975', code: '975', id: 'bt' },
  { label: '🇧🇴 +591', code: '591', id: 'bo' },
  { label: '🇧🇦 +387', code: '387', id: 'ba' },
  { label: '🇧🇼 +267', code: '267', id: 'bw' },
  { label: '🇧🇷 +55', code: '55', id: 'br' },
  { label: '🇧🇳 +673', code: '673', id: 'bn' },
  { label: '🇧🇬 +359', code: '359', id: 'bg' },
  { label: '🇧🇫 +226', code: '226', id: 'bf' },
  { label: '🇧🇮 +257', code: '257', id: 'bi' },
  { label: '🇰🇭 +855', code: '855', id: 'kh' },
  { label: '🇨🇲 +237', code: '237', id: 'cm' },
  { label: '🇨🇦 +1', code: '1', id: 'ca' },
  { label: '🇨🇻 +238', code: '238', id: 'cv' },
  { label: '🇨🇫 +236', code: '236', id: 'cf' },
  { label: '🇹🇩 +235', code: '235', id: 'td' },
  { label: '🇨🇱 +56', code: '56', id: 'cl' },
  { label: '🇨🇳 +86', code: '86', id: 'cn' },
  { label: '🇨🇴 +57', code: '57', id: 'co' },
  { label: '🇰🇲 +269', code: '269', id: 'km' },
  { label: '🇨🇬 +242', code: '242', id: 'cg' },
  { label: '🇨🇩 +243', code: '243', id: 'cd' },
  { label: '🇨🇷 +506', code: '506', id: 'cr' },
  { label: '🇭🇷 +385', code: '385', id: 'hr' },
  { label: '🇨🇺 +53', code: '53', id: 'cu' },
  { label: '🇨🇾 +357', code: '357', id: 'cy' },
  { label: '🇨🇿 +420', code: '420', id: 'cz' },
  { label: '🇩🇰 +45', code: '45', id: 'dk' },
  { label: '🇩🇯 +253', code: '253', id: 'dj' },
  { label: '🇩🇲 +1', code: '1', id: 'dm' },
  { label: '🇩🇴 +1', code: '1', id: 'do' },
  { label: '🇪🇨 +593', code: '593', id: 'ec' },
  { label: '🇪🇬 +20', code: '20', id: 'eg' },
  { label: '🇸🇻 +503', code: '503', id: 'sv' },
  { label: '🇬🇶 +240', code: '240', id: 'gq' },
  { label: '🇪🇷 +291', code: '291', id: 'er' },
  { label: '🇪🇪 +372', code: '372', id: 'ee' },
  { label: '🇸🇿 +268', code: '268', id: 'sz' },
  { label: '🇪🇹 +251', code: '251', id: 'et' },
  { label: '🇫🇯 +679', code: '679', id: 'fj' },
  { label: '🇫🇮 +358', code: '358', id: 'fi' },
  { label: '🇫🇷 +33', code: '33', id: 'fr' },
  { label: '🇬🇦 +241', code: '241', id: 'ga' },
  { label: '🇬🇲 +220', code: '220', id: 'gm' },
  { label: '🇬🇪 +995', code: '995', id: 'ge' },
  { label: '🇩🇪 +49', code: '49', id: 'de' },
  { label: '🇬🇭 +233', code: '233', id: 'gh' },
  { label: '🇬🇷 +30', code: '30', id: 'gr' },
  { label: '🇬🇩 +1', code: '1', id: 'gd' },
  { label: '🇬🇹 +502', code: '502', id: 'gt' },
  { label: '🇬🇳 +224', code: '224', id: 'gn' },
  { label: '🇬🇼 +245', code: '245', id: 'gw' },
  { label: '🇬🇾 +592', code: '592', id: 'gy' },
  { label: '🇭🇹 +509', code: '509', id: 'ht' },
  { label: '🇭🇳 +504', code: '504', id: 'hn' },
  { label: '🇭🇺 +36', code: '36', id: 'hu' },
  { label: '🇮🇸 +354', code: '354', id: 'is' },
  { label: '🇮🇳 +91', code: '91', id: 'in' },
  { label: '🇮🇩 +62', code: '62', id: 'id' },
  { label: '🇮🇷 +98', code: '98', id: 'ir' },
  { label: '🇮🇶 +964', code: '964', id: 'iq' },
  { label: '🇮🇪 +353', code: '353', id: 'ie' },
  { label: '🇮🇱 +972', code: '972', id: 'il' },
  { label: '🇮🇹 +39', code: '39', id: 'it' },
  { label: '🇯🇲 +1', code: '1', id: 'jm' },
  { label: '🇯🇵 +81', code: '81', id: 'jp' },
  { label: '🇯🇴 +962', code: '962', id: 'jo' },
  { label: '🇰🇿 +7', code: '7', id: 'kz' },
  { label: '🇰🇪 +254', code: '254', id: 'ke' },
  { label: '🇰🇮 +686', code: '686', id: 'ki' },
  { label: '🇰🇵 +850', code: '850', id: 'kp' },
  { label: '🇰🇷 +82', code: '82', id: 'kr' },
  { label: '🇰🇼 +965', code: '965', id: 'kw' },
  { label: '🇰🇬 +996', code: '996', id: 'kg' },
  { label: '🇱🇦 +856', code: '856', id: 'la' },
  { label: '🇱🇻 +371', code: '371', id: 'lv' },
  { label: '🇱🇧 +961', code: '961', id: 'lb' },
  { label: '🇱🇸 +266', code: '266', id: 'ls' },
  { label: '🇱🇷 +231', code: '231', id: 'lr' },
  { label: '🇱🇾 +218', code: '218', id: 'ly' },
  { label: '🇱🇮 +423', code: '423', id: 'li' },
  { label: '🇱🇹 +370', code: '370', id: 'lt' },
  { label: '🇱🇺 +352', code: '352', id: 'lu' },
  { label: '🇲🇬 +261', code: '261', id: 'mg' },
  { label: '🇲🇼 +265', code: '265', id: 'mw' },
  { label: '🇲🇾 +60', code: '60', id: 'my' },
  { label: '🇲🇻 +960', code: '960', id: 'mv' },
  { label: '🇲🇱 +223', code: '223', id: 'ml' },
  { label: '🇲🇹 +356', code: '356', id: 'mt' },
  { label: '🇲🇭 +692', code: '692', id: 'mh' },
  { label: '🇲🇷 +222', code: '222', id: 'mr' },
  { label: '🇲🇺 +230', code: '230', id: 'mu' },
  { label: '🇲🇽 +52', code: '52', id: 'mx' },
  { label: '🇫🇲 +691', code: '691', id: 'fm' },
  { label: '🇲🇩 +373', code: '373', id: 'md' },
  { label: '🇲🇨 +377', code: '377', id: 'mc' },
  { label: '🇲🇳 +976', code: '976', id: 'mn' },
  { label: '🇲🇪 +382', code: '382', id: 'me' },
  { label: '🇲🇦 +212', code: '212', id: 'ma' },
  { label: '🇲🇿 +258', code: '258', id: 'mz' },
  { label: '🇲🇲 +95', code: '95', id: 'mm' },
  { label: '🇳🇦 +264', code: '264', id: 'na' },
  { label: '🇳🇷 +674', code: '674', id: 'nr' },
  { label: '🇳🇵 +977', code: '977', id: 'np' },
  { label: '🇳🇱 +31', code: '31', id: 'nl' },
  { label: '🇳🇿 +64', code: '64', id: 'nz' },
  { label: '🇳🇮 +505', code: '505', id: 'ni' },
  { label: '🇳🇪 +227', code: '227', id: 'ne' },
  { label: '🇳🇬 +234', code: '234', id: 'ng' },
  { label: '🇳🇴 +47', code: '47', id: 'no' },
  { label: '🇴🇲 +968', code: '968', id: 'om' },
  { label: '🇵🇰 +92', code: '92', id: 'pk' },
  { label: '🇵🇼 +680', code: '680', id: 'pw' },
  { label: '🇵🇸 +970', code: '970', id: 'ps' },
  { label: '🇵🇦 +507', code: '507', id: 'pa' },
  { label: '🇵🇬 +675', code: '675', id: 'pg' },
  { label: '🇵🇾 +595', code: '595', id: 'py' },
  { label: '🇵🇪 +51', code: '51', id: 'pe' },
  { label: '🇵🇭 +63', code: '63', id: 'ph' },
  { label: '🇵🇱 +48', code: '48', id: 'pl' },
  { label: '🇵🇹 +351', code: '351', id: 'pt' },
  { label: '🇶🇦 +974', code: '974', id: 'qa' },
  { label: '🇷🇴 +40', code: '40', id: 'ro' },
  { label: '🇷🇺 +7', code: '7', id: 'ru' },
  { label: '🇷🇼 +250', code: '250', id: 'rw' },
  { label: '🇰🇳 +1', code: '1', id: 'kn' },
  { label: '🇱🇨 +1', code: '1', id: 'lc' },
  { label: '🇻🇨 +1', code: '1', id: 'vc' },
  { label: '🇼🇸 +685', code: '685', id: 'ws' },
  { label: '🇸🇲 +378', code: '378', id: 'sm' },
  { label: '🇸🇹 +239', code: '239', id: 'st' },
  { label: '🇸🇦 +966', code: '966', id: 'sa' },
  { label: '🇸🇳 +221', code: '221', id: 'sn' },
  { label: '🇷🇸 +381', code: '381', id: 'rs' },
  { label: '🇸🇨 +248', code: '248', id: 'sc' },
  { label: '🇸🇱 +232', code: '232', id: 'sl' },
  { label: '🇸🇬 +65', code: '65', id: 'sg' },
  { label: '🇸🇰 +421', code: '421', id: 'sk' },
  { label: '🇸🇮 +386', code: '386', id: 'si' },
  { label: '🇸🇧 +677', code: '677', id: 'sb' },
  { label: '🇸🇴 +252', code: '252', id: 'so' },
  { label: '🇿🇦 +27', code: '27', id: 'za' },
  { label: '🇸🇸 +211', code: '211', id: 'ss' },
  { label: '🇪🇸 +34', code: '34', id: 'es' },
  { label: '🇱🇰 +94', code: '94', id: 'lk' },
  { label: '🇸🇩 +249', code: '249', id: 'sd' },
  { label: '🇸🇷 +597', code: '597', id: 'sr' },
  { label: '🇸🇪 +46', code: '46', id: 'se' },
  { label: '🇨🇭 +41', code: '41', id: 'ch' },
  { label: '🇸🇾 +963', code: '963', id: 'sy' },
  { label: '🇹🇼 +886', code: '886', id: 'tw' },
  { label: '🇹🇯 +992', code: '992', id: 'tj' },
  { label: '🇹🇿 +255', code: '255', id: 'tz' },
  { label: '🇹🇭 +66', code: '66', id: 'th' },
  { label: '🇹🇬 +228', code: '228', id: 'tg' },
  { label: '🇹🇴 +676', code: '676', id: 'to' },
  { label: '🇹🇹 +1', code: '1', id: 'tt' },
  { label: '🇹🇳 +216', code: '216', id: 'tn' },
  { label: '🇹🇷 +90', code: '90', id: 'tr' },
  { label: '🇹🇲 +993', code: '993', id: 'tm' },
  { label: '🇹🇻 +688', code: '688', id: 'tv' },
  { label: '🇺🇬 +256', code: '256', id: 'ug' },
  { label: '🇺🇦 +380', code: '380', id: 'ua' },
  { label: '🇦🇪 +971', code: '971', id: 'ae' },
  { label: '🇬🇧 +44', code: '44', id: 'gb' },
  { label: '🇺🇸 +1', code: '1', id: 'us' },
  { label: '🇺🇾 +598', code: '598', id: 'uy' },
  { label: '🇺🇿 +998', code: '998', id: 'uz' },
  { label: '🇻🇺 +678', code: '678', id: 'vu' },
  { label: '🇻🇦 +379', code: '379', id: 'va' },
  { label: '🇻🇪 +58', code: '58', id: 've' },
  { label: '🇻🇳 +84', code: '84', id: 'vn' },
  { label: '🇾🇪 +967', code: '967', id: 'ye' },
  { label: '🇿🇲 +260', code: '260', id: 'zm' },
  { label: '🇿🇼 +263', code: '263', id: 'zw' }
];
